import { createReactRenderer } from 'helpers/react-renderer';

import CancelSubscriptionModal from './CancelSubscriptionModal';

// eslint-disable-next-line consistent-return
function getCookie(name) {
  // eslint-disable-next-line prefer-template
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
}

export default class CancelSubscription {
  constructor() {
    this.bindCancelSubscriptionButton();
    this.cancelSubscriptionModal = null;

    if (getCookie('QSI_SI_dhWFtiYBPgXAoVE_intercept')) {
      this.waitForElm('#openCancelSubscriptionModal').then((elm) => {
        elm.setAttribute('disabled', true);
        this.showConfirmation();
      });
    }
  }

  bindCancelSubscriptionButton() {
    $(document).on('click', '#openCancelSubscriptionModal', (event) => {
      const targetEl = event.target;

      if (targetEl instanceof HTMLAnchorElement) {
        $(targetEl).addClass('disabled');
      } else if (targetEl instanceof HTMLButtonElement) {
        $(targetEl).setAttribute('disabled', true);
      }

      this.showConfirmation();

      this.initCancelSubscriptionModal();
    });
  }

  showConfirmation() {
    const confirmationMessage = document.getElementById('requestCancelSubscriptionConfirmation');

    confirmationMessage.classList.remove('hidden');
  }

  waitForElm(selector) {
    // eslint-disable-next-line consistent-return
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  initCancelSubscriptionModal() {
    const RenderedComponent = createReactRenderer({
      component: CancelSubscriptionModal,
      selector: '[data-react-root="ReactModal"]',
    });

    this.cancelSubscription = RenderedComponent.mount();
  }
}
